import { Link } from "react-router-dom";
import { FileQuestion, ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-milk flex flex-col items-center justify-center p-4">
      <div className="max-w-md w-full text-center space-y-6">
        <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-cream border border-honey text-honey mb-4 shadow-sm">
          <FileQuestion className="w-10 h-10" strokeWidth={1.5} />
        </div>
        
        <h1 className="text-4xl font-display font-bold text-cocoa">Page Not Found</h1>
        
        <p className="text-mahogany">
          Oops! It looks like the page you are trying to visit doesn't exist, has been moved, or you don't have access to it.
        </p>
        
        <div className="pt-6">
          <Link 
            to="/" 
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-cocoa text-cream rounded-lg text-sm font-medium hover:bg-mahogany transition-colors shadow-sm"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Dashboard
          </Link>
        </div>
      </div>
      <div className="absolute bottom-8 text-xs text-mahogany/60 italic">
        Sulsa - Woven with love ✿
      </div>
    </div>
  );
}
